<div class="row">
  <div class="col-md-4">
    <div class="card mb-2">
      <div class="card-header">Public Holidays</div>
      <div class="card-body">
        <p class="mb-2">View and edit upcoming USA and South Africa non-trading dates.</p>
        <a routerLink="/tools/public-holidays" class="btn btn-sm btn-trakly-action">Open public holidays</a>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card mb-2">
      <div class="card-header">System Settings</div>
      <div class="card-body">
        <span>Automatic Deal Processing</span>
        <span
          class="btn-group ml-2"
          role="group"
          aria-label="Auto Processing Switch"
          (click)="toggleAutoProcessing()"
          *ngIf="autoProcessingSetting"
        >
          <button
            mdbBtn
            class="relative waves-light btn-sm btn"
            [ngClass]="{ 'btn-success': isAutoProcessingEnabled, 'btn-outline-light': !isAutoProcessingEnabled }"
          >
            Enabled
          </button>
          <button
            mdbBtn
            class="relative waves-light btn-sm btn"
            [ngClass]="{ 'btn-outline-light': isAutoProcessingEnabled, 'btn-danger': !isAutoProcessingEnabled }"
          >
            Disabled
          </button>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card mb-2">
      <div class="card-header">After Hours Trading: Pre-booking</div>
      <div class="card-body" *ngIf="!this.isItAfterHours()">
        <p>Only available after hours</p>
        <ul>
          <li>Weekdays before 7am or after 6pm</li>
          <li>Saturdays</li>
          <li>Sundays</li>
        </ul>
      </div>
      <div class="card-body" *ngIf="this.isItAfterHours()">
        <table class="w-100">
          <tr>
            <td colspan="2">Prebooking Processor Job</td>
            <td class="text-right align-middle">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="runPrebookingProcessor()"
                [disabled]="isBusyRunningPrebooking || isJobRunning"
              >
                <span
                  *ngIf="isJobRunning || isBusyRunningPrebooking"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span *ngIf="isJobRunning || isBusyRunningPrebooking">Running</span>
                <span *ngIf="!isJobRunning && !isBusyRunningPrebooking">Run Now</span>
              </button>
            </td>
          </tr>
          <tr>
            <td *ngIf="!isJobRunning">Last Run:</td>
            <td *ngIf="isJobRunning">Started:</td>

            <td *ngIf="isBusyCheckingStatus">Checking ...</td>
            <td *ngIf="isJobRunning && !isBusyCheckingStatus">
              <strong>{{ lastStarted }}</strong>
            </td>
            <td *ngIf="!isJobRunning && !isBusyCheckingStatus">
              <strong>{{ lastRun }}</strong>
            </td>

            <td class="text-right">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="checkJobStatus(jobName_Prebooking)"
                [disabled]="isBusyCheckingStatus"
              >
                <span *ngIf="isBusyCheckingStatus" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                <span>Check Status</span>
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="col-md-4" *ngIf="showRunJobsTools">
    <div class="card mb-2">
      <div class="card-header">Run jobs</div>
      <div class="card-body">
        <p class="mb-3">Dev-only: fire the same API jobs Logic Apps call on schedule.</p>
        <table class="w-100">
          <tr>
            <td colspan="2">Process Trades</td>
            <td class="text-right align-middle">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="runProcessTrades()"
                [disabled]="isBusyRunningProcessTrades || isProcessDealsRunning"
              >
                <span
                  *ngIf="isProcessDealsRunning || isBusyRunningProcessTrades"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span *ngIf="isProcessDealsRunning || isBusyRunningProcessTrades">Running</span>
                <span *ngIf="!isProcessDealsRunning && !isBusyRunningProcessTrades">Process Trades</span>
              </button>
            </td>
          </tr>
          <tr>
            <td *ngIf="!isProcessDealsRunning">Last Run:</td>
            <td *ngIf="isProcessDealsRunning">Started:</td>
            <td *ngIf="isBusyCheckingProcessDealsStatus">Checking ...</td>
            <td *ngIf="isProcessDealsRunning && !isBusyCheckingProcessDealsStatus">
              <strong>{{ processDealsLastStarted }}</strong>
            </td>
            <td *ngIf="!isProcessDealsRunning && !isBusyCheckingProcessDealsStatus">
              <strong>{{ processDealsLastRun }}</strong>
            </td>
            <td class="text-right">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="checkProcessDealsJobStatus()"
                [disabled]="isBusyCheckingProcessDealsStatus"
              >
                <span
                  *ngIf="isBusyCheckingProcessDealsStatus"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Check Status</span>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="2">Prebooking</td>
            <td class="text-right align-middle">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="runPrebookingProcessor()"
                [disabled]="isBusyRunningPrebooking || isJobRunning"
              >
                <span
                  *ngIf="isJobRunning || isBusyRunningPrebooking"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span *ngIf="isJobRunning || isBusyRunningPrebooking">Running</span>
                <span *ngIf="!isJobRunning && !isBusyRunningPrebooking">Prebooking</span>
              </button>
            </td>
          </tr>
          <tr>
            <td *ngIf="!isJobRunning">Last Run:</td>
            <td *ngIf="isJobRunning">Started:</td>
            <td *ngIf="isBusyCheckingStatus">Checking ...</td>
            <td *ngIf="isJobRunning && !isBusyCheckingStatus">
              <strong>{{ lastStarted }}</strong>
            </td>
            <td *ngIf="!isJobRunning && !isBusyCheckingStatus">
              <strong>{{ lastRun }}</strong>
            </td>
            <td class="text-right">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="checkJobStatus(jobName_Prebooking)"
                [disabled]="isBusyCheckingStatus"
              >
                <span
                  *ngIf="isBusyCheckingStatus"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Check Status</span>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Bank Balances
              <span *ngIf="bankBalancesMessage" class="d-block small text-muted">{{ bankBalancesMessage }}</span>
            </td>
            <td class="text-right align-middle">
              <button
                mdbBtn
                class="relative waves-light btn-sm btn"
                color="trakly-action"
                (click)="runBankBalances()"
                [disabled]="isBusyRunningBankBalances"
              >
                <span
                  *ngIf="isBusyRunningBankBalances"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span *ngIf="isBusyRunningBankBalances">Running</span>
                <span *ngIf="!isBusyRunningBankBalances">Bank Balances</span>
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
